
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetTimeline } from "@/request/common";
@Component({})
export default class Name extends Vue {
  private times: any = [];
  private ifOverstep: any = false; // 时间轴是否溢出，用来控制上一个和下一个按钮是否显示
  private oneTimeW: any = 120; // 单个时间轴的宽度
  private wrapW: any = 0;
  @Watch("patient", { immediate: true })
  private patientChange(content: any) {
    this.getTimeData();
  }
  private get patient() {
    return this.$store.state.patient;
  }

  private getTimeData() {
    if (!this.patient || !this.patient.id) {
      return;
    }
    const params: any = {
      params: {
        patient_id: this.patient.id,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTimeline(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.times = res.data;
        this.countTimeW();
      })
      .catch(() => {
        loading.close();
      });
  }
  private countTimeW() {
    this.$nextTick(() => {
      const W: any = (this.$refs.times as any).offsetWidth;
      if (this.times.length * this.oneTimeW > W) {
        this.ifOverstep = true;
        // 计算数量,100为预留的上一个，下一个图标位置
        const num: any = Math.floor((W - 100) / this.oneTimeW);
        this.wrapW = this.oneTimeW * num;
      } else {
        this.wrapW = this.oneTimeW * this.times.length;
        this.ifOverstep = false;
      }
      // 每次算完时间轴回到初始状态
      const ele: any = document.getElementById("shijianzhou");
      ele.style.left = 0;
    });
  }
  private goBefore() {
    const ele: any = document.getElementById("shijianzhou");
    const cLeft = ele.style.left ? Number(ele.style.left.split("px")[0]) : 0;
    if (cLeft > -this.oneTimeW) {
      this.$message.warning("已经到底了");
      return;
    } else {
      ele.style.left = cLeft + this.oneTimeW + "px";
    }
  }
  private goNext() {
    const maxL = this.oneTimeW * this.times.length - this.wrapW;
    const ele: any = document.getElementById("shijianzhou");
    const cLeft = ele.style.left ? Number(ele.style.left.split("px")[0]) : 0;
    if (-cLeft + this.oneTimeW > maxL) {
      this.$message.warning("已经到底了");
      return;
    } else {
      ele.style.left = cLeft - this.oneTimeW + "px";
    }
  }
  private goPinggu(item: any) {
    this.$store.commit("updateIfCompose", false);
    this.$router.push({
      path: "/main/manage/edit-ceping",
      query: {
        template_id: item.template_id,
        patient_id: this.patient.id,
        content_id: item.id,
      },
    });
  }
  private mounted() {
    this.getTimeData();
    window.onresize = () => {
      //屏幕尺寸变化就重新计算时间轴
      return (() => {
        this.countTimeW();
      })();
    };
  }
}
